import Vue from 'vue'

import uiSelect from './src/ui-select.vue';

Vue.component('ui-select', uiSelect);

export default uiSelect;



//////////////////
// WEBPACK FOOTER
// ./~/ui-select/index.js
// module id = 557
// module chunks = 0